import { render, staticRenderFns } from "./PresentacionProgressCircular.vue?vue&type=template&id=b1babf5c&scoped=true&"
import script from "./PresentacionProgressCircular.vue?vue&type=script&lang=js&"
export * from "./PresentacionProgressCircular.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionProgressCircular.vue?vue&type=style&index=0&id=b1babf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1babf5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VProgressCircular,
})
